import { CurrentTransformer } from './current-transformer';

export class ProvisioningOfCurrentTransformers {
  has_technical_reasons: boolean;
  operator?: string;
  preferred_date_for_pickup?: Date;
  confirmed_date_for_pickup?: Date;
  current_transformers: CurrentTransformer[] = [];
}
